import React from "react";
import PageHeader from "../components/PageHeader";

export default function PocsoAct() {
  const breadcrumbs = [
    { label: "Home", link: "/" },
    { label: "Acts & Guidelines", link: "/acts" },
    { label: "POCSO Act", active: true },
  ];

  return (
    <div>
      {/* Page Header */}
      <PageHeader title="POCSO Act" breadcrumbs={breadcrumbs} />

      {/* Main Section */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="row g-5">
            
            {/* Left Content */}
            <div className="col-lg-8 mx-auto">
              <div className="bg-white p-5 rounded-4 shadow-sm border-start border-4 border-primary">
                <h2 className="fw-bold text-primary mb-3 text-center">
                  POCSO Act (NCPCR, Govt. of India)
                </h2>
                <p className="text-secondary text-center mb-4">
                  Protection of Children from Sexual Offences Act, 2012 — Monitoring Roles & Responsibilities of NCPCR
                </p>

                <ul className="list-unstyled ps-3" style={{ lineHeight: "1.8" }}>
                  <li className="mb-3">
                    <i className="bi bi-check-circle text-primary me-2"></i>
                    To monitor the designation of Special Courts by State Governments;
                  </li>
                  <li className="mb-3">
                    <i className="bi bi-check-circle text-primary me-2"></i>
                    To monitor the appointment of Public Prosecutors by State Governments;
                  </li>
                  <li className="mb-3">
                    <i className="bi bi-check-circle text-primary me-2"></i>
                    To monitor the formulation of the guidelines described in section 39 of the Act by the State Governments, for the use of non-governmental organisations, professionals and experts or persons having knowledge of psychology, social work, physical health, mental health and child development to be associated with the pre-trial and trial stage to assist the child, and to monitor the application of these guidelines;
                  </li>
                  <li className="mb-3">
                    <i className="bi bi-check-circle text-primary me-2"></i>
                    To monitor the designing and implementation of modules for training police personnel and other concerned persons, including officers of the Central and State Governments, for the effective discharge of their functions under the Act;
                  </li>
                  <li className="mb-3">
                    <i className="bi bi-check-circle text-primary me-2"></i>
                    To monitor and support the Central Government and State Governments for the dissemination of information relating to the provisions of the Act through media including the television, radio and print media at regular intervals, so as to make the general public, children as well as their parents and guardians aware of the provisions of the Act;
                  </li>
                  <li className="mb-3">
                    <i className="bi bi-check-circle text-primary me-2"></i>
                    To call for a report on any specific case of child sexual abuse falling within the jurisdiction of a CWC;
                  </li>
                  <li className="mb-3">
                    <i className="bi bi-check-circle text-primary me-2"></i>
                    To collect information and data on its own or from the relevant agencies regarding reported cases of sexual abuse and their disposal under the processes established under the Act, including information on the following:-
                    <ul className="mt-2 ps-4">
                      <li>Number and details of offences reported under the Act.</li>
                      <li>Whether the procedures prescribed under the Act and rules were followed, including those regarding timeframes.</li>
                      <li>Details of arrangements for care and protection of victims of offences under this Act, including arrangements for emergency medical care and medical examination.</li>
                      <li>Details regarding assessment of the need for care and protection of a child by the concerned CWC in any specific case.</li>
                    </ul>
                  </li>
                  <li className="mb-0">
                    <i className="bi bi-check-circle text-primary me-2"></i>
                    To assess the implementation of the provisions of the Act and to include a report in a separate chapter in its Annual Report to the Parliament.
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </section>

    </div>
  );
}
